module.exports = __webpack_public_path__ + "img/trophy1.ba2265ef.svg";